import React from 'react';
import {
  Header,
  Segment,
} from 'semantic-ui-react';

import {
  CustomContainer,
  FollowingBtn,
  FollowingBtnGuide,
  ShareBtn,
} from '../../common';
import {
  formatDatetime,
} from '../../Utils';

export default ({
  authed,
  data: {
    city,
    country,
    domain,
    id,
    last_visit: lastVisit,
    name,
  },
}) => (
  <CustomContainer>
    <Segment>
      {
        authed ? (
          <FollowingBtn
            platform="dcard"
            type="school"
            id={id}
          />
        ) : (
          <FollowingBtnGuide />
        )
      }
      <ShareBtn />
      <Header
        as="h2"
        icon
        textAlign="center"
      >
        <Header.Content>
          {name}
          <Header.Subheader>
            上次留下足跡
            {formatDatetime(lastVisit)}
          </Header.Subheader>
          <Header.Subheader>
            {country}
            {' '}
            {city}
          </Header.Subheader>
          <Header.Subheader>
            {domain}
          </Header.Subheader>
        </Header.Content>
      </Header>
    </Segment>
  </CustomContainer>
);
